import { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { getErrorMessage } from '../services/errorMessages';
import { FiPlus, FiTrash2, FiX } from 'react-icons/fi';
import ConfirmModal from '../components/ConfirmModal';
import './Pages.css';

const Activities = () => {
  const { isAdmin } = useAuth();
  const [activities, setActivities] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [confirmAction, setConfirmAction] = useState(null);

  const fetchActivities = async () => {
    try {
      const { data } = await api.get('/activities');
      setActivities(data);
    } catch {
      // fetch failed silently
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchActivities(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post('/activities', { name });
      setShowModal(false);
      setName('');
      fetchActivities();
    } catch (err) {
      setError(getErrorMessage(err));
    }
  };

  const handleDelete = (id) => {
    setConfirmAction({
      title: 'აქტივობის წაშლა', message: 'ნამდვილად გსურთ წაშლა?', type: 'delete',
      onConfirm: async () => { try { await api.delete(`/activities/${id}`); fetchActivities(); } catch { /* ignored */ } setConfirmAction(null); },
    });
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>აქტივობები</h1>
          <p className="page-subtitle">აქტივობების მართვა</p>
        </div>
        {isAdmin && (
          <button className="btn-primary" onClick={() => setShowModal(true)}>
            <FiPlus /> დამატება
          </button>
        )}
      </div>

      {loading ? (
        <div className="loading">იტვირთება...</div>
      ) : (
        <div className="activities-grid">
          {activities.map((a) => (
            <div key={a.id} className="activity-card">
              <span className="activity-name">{a.name}</span>
              {isAdmin && (
                <button className="btn-icon btn-danger" onClick={() => handleDelete(a.id)} title="წაშლა">
                  <FiTrash2 />
                </button>
              )}
            </div>
          ))}
          {activities.length === 0 && <div className="empty-state-card">აქტივობები არ არის</div>}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>ახალი აქტივობა</h3>
              <button className="btn-icon" onClick={() => setShowModal(false)}><FiX /></button>
            </div>
            <form onSubmit={handleSubmit} className="modal-form">
              {error && <div className="error-message">{error}</div>}
              <div className="form-group">
                <label>დასახელება</label>
                <input value={name} onChange={(e) => setName(e.target.value)} placeholder="შეიყვანეთ აქტივობის დასახელება" required />
              </div>
              <button type="submit" className="btn-primary btn-full" disabled={!name.trim()}>დამატება</button>
            </form>
          </div>
        </div>
      )}
      {confirmAction && <ConfirmModal {...confirmAction} onCancel={() => setConfirmAction(null)} />}
    </div>
  );
};

export default Activities;
